import { Box, Typography } from "@mui/material";
import { makeStyles } from "@material-ui/styles";
import { useNavigate } from "react-router-dom";
import ApCustomDivider from "./ApCustomDivider";
import { FooterLink, FooterProps } from "../constants/types";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  footerContainer: {
    zIndex: 1201,
    position: "relative",
    height: "37px",
    backgroundColor: theme.aapnoParichayTheme.primaryContainer,
    paddingTop: "10px",
    color: theme.aapnoParichayTheme.onPrimaryContainer,
    "& p": {
      fontSize: "12px",
    },
  },
  divider: { backgroundColor: theme.aapnoParichayTheme.onPrimaryContainer },
  footerBody: {
    margin: "5px 20px",
    display: "flex",
    height: "20px",
    justifyContent: "space-between",
    fontSize: "12px",
    alignItems: "center",
  },
  displayFlex: { display: "flex" },
  title: {
    marginLeft: "20px",
    color: theme.aapnoParichayTheme.onPrimaryContainer,
  },
  footerLinkBody: { marginLeft: "20px" },
  footerItem: {
    color: theme.aapnoParichayTheme.onPrimaryContainer,
    cursor: "pointer",
  },
}));

const footerItems: FooterLink[] = [];

const ApFooter = ({
  title = `© ${new Date().getFullYear()} aapno parichay`,
  customStyles,
}: FooterProps) => {
  const navigate = useNavigate();
  const classes = useStyles();
  return (
    <div className={classes.footerContainer}>
      <ApCustomDivider variant="middle" className={classes.divider} />
      <Box className={classes.footerBody} style={customStyles}>
        <Typography className={classes.title}>{title}</Typography>
        <Box className={classes.displayFlex}>
          {footerItems?.map((item: FooterLink, index: number) => {
            return (
              <Box key={index} className={classes.footerLinkBody}>
                <Typography
                  className={classes.footerItem}
                  onClick={() => navigate(item.link)}
                >
                  {item.label}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Box>
    </div>
  );
};

export default ApFooter;
